import { Component, OnInit } from '@angular/core';
import { AuthService } from 'src/app/services/auth.service';
import { UserService } from 'src/app/services/user.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-how-does-it-work',
  templateUrl: './how-does-it-work.component.html',
  styleUrls: ['./how-does-it-work.component.scss']
})
export class HowDoesItWorkComponent implements OnInit {
  currentUser: any;
  login: boolean = false;
  obfuscated: boolean = false;
  loading: boolean = true;

  constructor(
    private authService: AuthService,
    private userService: UserService
  ) {}

  ngOnInit(): void {
    let castUser: Subscription;

    castUser = this.authService.castCurrentUser.subscribe(async (res: any) => {
      this.currentUser = await res;
      if (this.currentUser?.id) {
        this.userService.personalInfo(this.currentUser?.id).subscribe((res: any) => {
          this.login = !!(res?.subscribed || res?.user_plan === 1);
          this.obfuscated = !!res?.obfuscated;
          this.loading = false;
        });
      } else {
        this.login = false;
        this.loading = false;
      }
      castUser.unsubscribe();
    });
  }
}


